import { render, staticRenderFns } from "./AudioSync.vue?vue&type=template&id=18c93d97&scoped=true&"
import script from "./AudioSync.vue?vue&type=script&lang=js&"
export * from "./AudioSync.vue?vue&type=script&lang=js&"
import style0 from "./AudioSync.vue?vue&type=style&index=0&id=18c93d97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c93d97",
  null
  
)

export default component.exports